import React, { Component } from 'react'
import { connect } from 'react-redux'
import Layout from './../../wrapper'
import { AcManagements } from '../../Components/AccountManagements/accountManagements'
import withTranslationWrapper from '../../HOC/HocTranslate'
import { notifyError, notifySuccess } from '../../Utils/CustomNotifcations'
import { logInUserInfo } from '../../Actions/Users'
import { ServerInfo } from '../../Actions/serverSetting'
import { checkPrivileges } from '../../Helpers'
import withRoutes from '../../HOC/HocRoutes'
import { apiFetch } from '../../Utils/apiFetch'

class AccountManagements extends Component {
  constructor (props) {
    super(props)
    this.state = {
      userInfo: {},
      userFetch: false
    }
  }

  componentWillMount () {
        // this.props.dispatch(Notifications.removeAll())
    if (!this.props.ServerSetting) {
      apiFetch('/api/server').then(response => {
        if (response.ok) {
          response.json().then(res => {
            if(res.status ==='success'){   
              let server = res.data
              this.props.dispatch(ServerInfo(server))
            }
            else if(res?.statusCode === '440'){
              window.location.replace('/login')
            }
            else if(res.statusCode){
              var err = res?.message.split(':')
              err[1] =err[1].replace(')', "")
              this.props.dispatch(
                notifyError(err[1])
              )
            }
          })
        }else{
          throw response
        }
      })  .catch(e => {
        this.props.dispatch(notifyError('somethingWentWrong'))
      })
    }
  }

  render () {
    if (checkPrivileges('user')) {
      if (this.props.logInUser) {
        return (
          <Layout
            {...this.props}
            noSidebar
          >
            <AcManagements {...this.props} />
          </Layout>
        )
      } else
        apiFetch('/api/session?app=2bd5bd10345cd1555b14c221ec6e8647c46ee21e8ee45312', {
          headers: { Accept: 'application/json; odata=verbose' }
        }).then(response => {
          if (response.ok) {
            response.json().then(res => {
              if(res.status ==='success'){  
                let userInfo = res.data
                this.props.setActiveLanguage(userInfo?.attributes?.lang || 'en')
                this.props.dispatch(logInUserInfo(userInfo))
              }
              else if(res?.statusCode === '440'){
                window.location.replace('/login')
              }
              else if(res.statusCode){
                var err = res?.message.split(':')
                err[1] =err[1].replace(')', "")
                this.props.dispatch(
                  notifyError(err[1])
                )
                this.props.navigate('/logout')
              }
            })
          } else {
            this.props.navigate('/logout')
            throw response
          }
        })  
        .catch(e => {
          this.props.dispatch(notifyError('somethingWentWrong'))
        })
      return null
    } else {
      return <h1>Page Not Found</h1>
    }
  }
}

const mapStateToProps = state => ({
  ServerSetting: state.ServerSetting,
  logInUser: state.logInUsers
})

export default connect(mapStateToProps)(withRoutes(withTranslationWrapper(AccountManagements)))
